<template>
  <div class="solution">
    <!-- 顶部 banner -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">农产品产销交易与品牌溯源解决方案</h1>
        <p class="banner-desc aw-anim">产地产销数字化交易平台，全链条溯源可信管控，拓宽农产品销路，实现消费帮扶数字化管理</p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 方案简介 -->
    <section class="intro-section">
      <h2 class="section-title aw-anim">方案简介</h2>
      <div class="intro-body">
        <div class="intro-img">
          <img :src="introImg" alt="方案配图" />
        </div>
        <div class="intro-text aw-anim">
          <p>{{ introText }}</p>
        </div>
      </div>
    </section>

    <!-- 行业痛点 -->
    <section class="pain-section">
      <h2 class="section-title aw-anim">行业痛点</h2>
      <div class="pain-grid">
        <div class="pain-card aw-anim" v-for="(item, index) in painPoints" :key="index">
          <img class="pain-icon" :src="item.icon" :alt="item.title" />
          <h3 class="pain-title">{{ item.title }}</h3>
          <p class="pain-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 核心能力 -->
    <section class="cap-section">
      <h2 class="section-title aw-anim">核心能力</h2>
      <div class="cap-grid">
        <div class="cap-card aw-anim" :class="{ featured: item.featured }" v-for="(item, index) in capabilities"
          :key="index">
          <img class="cap-icon" :src="item.icon" :alt="item.title" />
          <h3 class="cap-title">{{ item.title }}</h3>
          <p class="cap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 客户价值 -->
    <section class="value-section">
      <h2 class="section-title aw-anim">客户价值</h2>
      <div class="value-body">
        <div class="value-text aw-anim">
          <p>{{ valueText }}</p>
        </div>
        <div class="value-img">
          <img :src="valueImg" alt="客户价值全景" />
        </div>
      </div>
    </section>
    <!-- 在线留言 -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "SolutionPage5",
  components: { ContactMessageForm },
  data() {
    return {
      introImg: require("@/assets/solution/productTrace/intro_mock.png"),
      valueImg: require("@/assets/solution/productTrace/value_mock.png"),
      introText: "聚焦农产品产销脱节、品牌薄弱、溯源缺失等痛点，打造集产地货源管理、线上交易、订单农业、一物一码溯源、消费帮扶、渠道分销于一体的全链路产销平台。打通产地、加工企业、渠道商、终端消费者链路，依托交易数据与溯源体系，助力区域农产品品牌化、市场化发展",
      valueText: "搭建产地自主可控的线上交易平台，拓宽农产品销售渠道，摆脱第三方平台依赖；溯源体系筑牢产品信任根基，助力农产品品牌溢价；实现消费帮扶、订单农业数字化管控，高效完成项目上报与归档",
      painPoints: [
        {
          icon: require("@/assets/solution/productTrace/sol_isol_pain1.png"),
          title: "渠道缺失",
          desc: "产地农产品缺乏线上流通渠道，产销信息闭塞，优质农产品溢价难",
        },
        {
          icon: require("@/assets/solution/productTrace/sol_isol_pain2.png"),
          title: "溯源断裂",
          desc: "农产品生产、加工、物流、质检信息碎片化，无可信溯源体系，消费者信任度低",
        },
        {
          icon: require("@/assets/solution/productTrace/sol_isol_pain3.png"),
          title: "数字化载体缺失",
          desc: "消费帮扶、订单农业无专属数字化载体，数据统计、项目归档繁琐",
        },
        {
          icon: require("@/assets/solution/productTrace/sol_isol_pain4.png"),
          title: "管理零散效率低",
          desc: "农产品交易、库存、物流管理零散，对账复杂，流通效率低下",
        }
      ],
      capabilities: [
        {
          icon: require("@/assets/solution/productTrace/sol_cap1.png"),
          title: "全场景交易体系",
          desc: "田头市场线上商城、消费帮扶专区、订单农业、团购分销、询价撮合",
          featured: false,
        },
        {
          icon: require("@/assets/solution/productTrace/sol_cap2.png"),
          title: "一物一码溯源体系",
          desc: "种植农事、投入品使用、加工质检、物流运输全链条溯源，扫码可视化查询",
          featured: false,
        },
        {
          icon: require("@/assets/solution/productTrace/sol_cap3.png"),
          title: "产销协同管控",
          desc: "货源管理、库存监控、订单履约、物流跟踪、售后管控一体化",
          featured: false,
        },
        {
          icon: require("@/assets/solution/productTrace/sol_cap4.png"),
          title: "客户增长赋能",
          desc: "客户画像、会员运营、私域营销、裂变分销，打造交易增长飞轮",
          featured: false,
        },
        {
          icon: require("@/assets/solution/productTrace/sol_cap5.png"),
          title: "数据可视化",
          desc: "产销数据统计、帮扶数据自动汇总、流通态势分析",
          featured: true,
        }
      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.solution {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("~@/assets/solution/productTrace/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  margin-bottom: 40px;
  text-align: center;
  line-height: 32px;
}

/* ============ 方案简介 ============ */
.intro-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.intro-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.intro-img {
  //   flex: 0 0 518px;

  img {
    width: 518px;
    height: 345px;
    display: block;
  }
}

.intro-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

/* ============ 行业痛点 ============ */
.pain-section {
  padding: 80px 0;
  background: #ffffff;
}

.pain-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.pain-card {
  background: #f5f8fe;
  border-radius: 12px;
  //   padding: 44px 28px;/
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  padding: 32px 24px 12px 32px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }
}

.pain-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.pain-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
  line-height: 20px;
}

.pain-desc {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  margin: 0;
  text-align: justify;
  text-align-last: center;
}

/* ============ 核心能力 ============ */
.cap-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.cap-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cap-card {
  grid-column: span 2;
  background: #ffffff;
  //   border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 32px 24px 0 32px;
  display: flex;
  flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  height: 250px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }

  /* 前两张各占半行 */
  &:nth-child(1),
  &:nth-child(2) {
    grid-column: span 3;
  }

  /* 第一张：蓝色渐变底 */
  &.featured {
    border: none;
    background: url("~@/assets/solution/bg2.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.cap-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.cap-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin: 0 0 16px;
}

.cap-desc {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

/* ============ 客户价值 ============ */
.value-section {
  padding: 80px 0;
  background: #ffffff;
}

.value-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.value-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

.value-img {
  img {
    width: 518px;
    height: 302px;
    display: block;
  }
}
</style>